<div class="Welcome">
    <div class="row">
        <div class="col-sm-6 col-md-4 col-lg-4 col-xs-12">
            <div class="[ info-card ]">
                <div class="ProductName Motor">
                    <img src="assets/theme/en/images/4.png">
                    <p style="margin-left:10px;">{{'Motor Insurance' | translate }}</p>
                    <div class="section">
                        <button class="btn btn-primary"
                            [routerLink]="['/NewDashboard/NewProposal']">{{'Buy Now'|translate}}</button>
                    </div>
                </div>


                <!--              
                <div class="[ info-card-details ] animate">
                    <div class="[ info-card-header ]">
                        <h1> Motor Insurance </h1>
                    </div>
                    <div class="[ info-card-detail ]">
                        <p>People often say that beauty is in the eye of the beholder, and I say that the most liberating thing about beauty is realizing that you are the beholder.</p>
                         <button class="btn btn-primary" [routerLink]="['/NewDashboard/NewProposal']">Buy Now</button>
                    </div>
                </div> -->
            </div>
        </div>
        <div class="col-sm-6 col-md-4 col-lg-4 col-xs-12">
            <div class="[ info-card ]">
                <div class="ProductName Med">
                    <img src="assets/theme/en/images/3.png">
                    <p>{{'MEDICAL MALPRACTICE INSURANCE' | translate }}</p>
                    <div class="section">
                        <!-- <button class="btn btn-primary"
                            [routerLink]="['/NewDashboard/MedmalNewProposal']">{{'Buy Now'|translate}}</button>
                    -->
                        <button class="btn btn-primary"
                        (click)="CommingSoon()">{{'Buy Now'|translate}}</button>
                        </div>


                </div>


                <!-- <div class="[ info-card-details ] animate">
                    <div class="[ info-card-header ]">
                        <h1> Medical Malpractice </h1>
                    </div>
                    <div class="[ info-card-detail ]">
                        <p>People often say that beauty is in the eye of the beholder, and I say that the most liberating thing about beauty is realizing that you are the beholder.</p>
                        <button class="btn btn-primary" [routerLink]="['/NewDashboard/MedmalNewProposal']">Buy Now</button>
                    </div>
                </div> -->
            </div>
        </div>

        <div class="col-sm-6 col-md-4 col-lg-4 col-xs-12">
            <div class="[ info-card ]">
                <div class="ProductName Tra">
                    <img src="assets/theme/en/images/1.jpg">
                    <p>{{'Travel Insurance'| translate }}</p>
                    <div class="section">
                            <!-- <button class="btn btn-primary"
                            [routerLink]="['/NewDashboard/TravelPolicy']">{{'Buy Now'|translate}}</button>
                             -->
                            <button class="btn btn-primary"
                            (click)="Travel()">{{'Buy Now'|translate}}</button>
                    </div>

                </div>


                <!--                  
                    <div class="[ info-card-details ] animate">
                        <div class="[ info-card-header ]">
                            <h1> Travel Insurance </h1>
                        </div>
                        <div class="[ info-card-detail ]">
                            <p>People often say that beauty is in the eye of the beholder, and I say that the most liberating thing about beauty is realizing that you are the beholder.</p>
                             <button class="btn btn-primary" [routerLink]="['/NewDashboard/TravelPolicy']">Buy Now</button>
                        </div>
                    </div> -->
            </div>
        </div>



<!-- 
        <div class="col-sm-6 col-md-4 col-lg-3 col-xs-12">
            <div class="[ info-card ]">
                <div class="ProductName Dom">
                    <img src="assets/theme/en/images/product_icon_01.png">
                    <p>{{'Domestic Helper Insurance'| translate }}</p>
                    <div class="section">
                        <button class="btn btn-primary"
                            [routerLink]="['/NewDashboard/DomesticInsuredInfo']">{{'Buy Now'|translate}}</button>
                    </div>

                </div>


           
            </div>
        </div> -->




        <!-- <div class="col-sm-6 col-md-4 col-lg-3 col-xs-12">
            <div class="[ info-card ]">
                <div class="ProductName Medi">
                    <img src="assets/theme/en/images/1.png">
                    <p>{{'Medical Insurance' | translate }}</p>
                    <div class="section">
                        <a href="https://ubc.ggi-sa.com/Medical/#/LoginHome/Login" target="_blank"
                            class="btn btn-primary">{{'Buy Now'|translate}}</a>
                      
                    </div>
                </div>


            </div>
        </div> -->


    </div>

    <div class="Clears">

    </div>

    <!-- <div class="row">
           
           
            

            <div class="col-sm-6 col-md-3 col-lg-3 col-xs-12">
                    <div class="[ info-card ]">
                            <div class="ProductName">
                                    <img  src="assets/theme/en/images/product_icon_02.png">
                                    <p>People often say that beauty is in the eye of the beholder, and I say that the most liberating thing about beauty is realizing that you are the beholder.</p>
                            </div>
                        <div class="[ info-card-details ] animate">
                            <div class="[ info-card-header ]">
                                <h1> Home Insurance </h1>
                            </div>
                            <div class="[ info-card-detail ]">
                                <p>People often say that beauty is in the eye of the beholder, and I say that the most liberating thing about beauty is realizing that you are the beholder.</p>
                                    <button class="btn btn-primary">Buy Now</button>
                            
                            </div>
                        </div>
                    </div>
                </div>

                <div class="col-sm-6 col-md-3 col-lg-3 col-xs-12">
                        <div class="[ info-card ]">
                                <div class="ProductName">
                                        <img  src="assets/theme/en/images/product_icon_01.png">
                                        <p>People often say that beauty is in the eye of the beholder, and I say that the most liberating thing about beauty is realizing that you are the beholder.</p>
                                </div>
                         
                            <div class="[ info-card-details ] animate">
                                <div class="[ info-card-header ]">
                                    <h1> Shops Insurance </h1>
                                </div>
                                <div class="[ info-card-detail ]">
                                    <p>People often say that beauty is in the eye of the beholder, and I say that the most liberating thing about beauty is realizing that you are the beholder.</p>
                                     <button class="btn btn-primary">Buy Now</button>
                                </div>
                            </div>
                        </div>
                    </div>
        </div> -->
</div>


// WEBPACK FOOTER //
// D:/GGI/LIMRA_GGI/PROMOSND95/GGI_ONLINE_ANGULAR__2022_10_17_ClaimTracking/src/Pages/Welcome/Welcome.html